import ReactDOM from "react-dom/client";
import React from "react";
import { Checkout } from "./components/checkout/Checkout";

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

const containers = <NodeListOf<HTMLElement>>document.querySelectorAll(".checkout-section");

containers.forEach((container) => {
    const contentElement = container.querySelector(".content");
    const root = ReactDOM.createRoot(contentElement);
    root.render(React.createElement(Checkout, {}));
});
